import i18n from 'i18n'
import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"
import { FEATURES } from 'app/@common/constants'

export default function SelectFeatures({...props}) {

    const myProps = {
        urlAjax: FEATURES.LIST_URL,
        placeholder: i18n.t('common:filters.featuresPlaceholder'), icon: {icon: 'user-tag'},
        isMulti: true,
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}